import React from 'react';
import { LoadingIndicator } from '@/components/application/loading-indicator/loading-indicator';

export const LoadingPage: React.FC = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <LoadingIndicator type="line-simple" size="md" />
    </div>
  );
};

export const LoadingDiv = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <LoadingIndicator type="line-simple" size="md" />
    </div>
  );
};
